/* hasValue - function takes any variable and will return TRUE for non empty and FALSE for empty */
export function hasValue(value: string) {
    if (value) {
        return true;
    } else {
        return false;
    }
}